module.exports = __webpack_public_path__ + "img/tshirt.66e40f06.jpg";